module.exports = __webpack_public_path__ + "img/interpret_data_help.6d9332c2.svg";